module.exports = __webpack_public_path__ + "static/img/parallax3.1720c18c.jpg";